module.exports = __webpack_public_path__ + "static/img/39.ef85e52.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/39.png
// module id = F4Sp
// module chunks = 1